import { AlpineComponent } from '@alpinejs/csp';

const ScrollInfo = (): AlpineComponent => ({
  lottie: undefined,
  entered: false,
  init() {
    (async () => {
      const { default: Lottie } = await import('lottie-web');

      if (this.$refs.animation) {
        this.lottie = Lottie.loadAnimation({
          container: this.$refs.animation,
          renderer: 'svg',
          loop: false,
          autoplay: false,
          path: this.$refs.animation.dataset.animation
        });
      }
    })();
  },
  handleScroll() {
    if (!this.lottie) return;

    const rect = this.$root.getBoundingClientRect();
    const viewportHeight = window.innerHeight;

    const position =
      (viewportHeight - rect.top) / (viewportHeight + rect.height * 0.5);

    const percentage = Math.max(0, Math.min(1, position));

    const maxFrames = this.lottie.totalFrames;
    const frame = Math.floor(maxFrames * percentage);
    this.lottie.goToAndStop(frame, true);
  },
  handleLeave() {
    if (this.lottie && this.entered && window.innerWidth >= 768) {
      this.entered = false;
      this.lottie.goToAndStop(0);
    }
  }
});

export default ScrollInfo;
